const m = require('mithril');
const prop = require('mithril/stream');
const modal = require('../layout/components/modal');
const loaders = require('../layout/components/loaders');
const fileInput = require('../components/inputs/fileInput');
const ToggleSwitch = require('../components/toggleSwitch');
const templateDeviceSelector = require('../binding/components/templateDeviceSelector');
const templateInputModeTabs = require('../binding/components/templateInputModeTabs');

var bindEquipmentModal = {};

function extractErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (typeof error.error === 'string' && error.error) return error.error;
  if (typeof error.message === 'string' && error.message) return error.message;
  if (Array.isArray(error.errors) && error.errors.length) {
    var first = error.errors[0];
    if (typeof first === 'string') return first;
    if (first && typeof first.message === 'string') return first.message;
  }
  if (error.response && typeof error.response === 'object') {
    return extractErrorMessage(error.response);
  }
  return '';
}

function fallbackFormatClassTemplateLabel(template) {
  var normalized = template && typeof template === 'object' ? template : {};
  var name = typeof normalized.name === 'string' ? normalized.name.trim() : '';
  var equipmentRid = typeof normalized.equipmentRid === 'string' ? normalized.equipmentRid.trim() : '';
  var displayName = name || 'Default';
  return equipmentRid ? `${displayName} (Template ID ${equipmentRid})` : displayName;
}

function fallbackBase64ToUint8Array(base64String) {
  var decoded = window.atob(base64String || '');
  var bytes = new Uint8Array(decoded.length);
  for (var i = 0; i < decoded.length; i++) {
    bytes[i] = decoded.charCodeAt(i);
  }
  return bytes;
}

function fallbackDecodeByteArrayToText(byteArray) {
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder('utf-8').decode(byteArray);
  }
  var text = '';
  for (var i = 0; i < byteArray.length; i++) {
    text += String.fromCharCode(byteArray[i]);
  }
  return decodeURIComponent(escape(text));
}

bindEquipmentModal.open = function (options) {
  var config = options && typeof options === 'object' ? options : {};
  var equipment = config.equipment || null;
	  var classTemplates = Array.isArray(config.classTemplates)
	    ? config.classTemplates.filter(function (template) {
	        return Boolean(template && template.equipmentRid);
	      })
	    : [];
  var formatClassTemplateLabel = typeof config.formatClassTemplateLabel === 'function'
    ? config.formatClassTemplateLabel
    : fallbackFormatClassTemplateLabel;
  var base64ToUint8Array = typeof config.base64ToUint8Array === 'function'
    ? config.base64ToUint8Array
    : fallbackBase64ToUint8Array;
  var decodeByteArrayToText = typeof config.decodeByteArrayToText === 'function'
    ? config.decodeByteArrayToText
    : fallbackDecodeByteArrayToText;
  var hideMenu = typeof config.hideMenu === 'function' ? config.hideMenu : function () {};
  var showBindingExportFlash = typeof config.showBindingExportFlash === 'function'
    ? config.showBindingExportFlash
    : function () {};

  var targetEquipmentId = equipment && equipment['@rid'] ? equipment['@rid'].toString() : '';
  if (!targetEquipmentId) {
    showBindingExportFlash('error', 'Error');
    return;
  }

  hideMenu();

  var defaultBooleanOptions = [
    { key: 'updateDatasetBindings', label: 'Update Dataset Bindings' },
    { key: 'overwriteDatasetBindings', label: 'Overwrite Dataset Bindings' },
    { key: 'createMissingDatasetsAndColumns', label: 'Create Missing Datasets/Columns' },
    { key: 'createMissingChildEquipment', label: 'Create Missing Child Equipment' },
    { key: 'updateAndOverwriteEquipmentAnimations', label: 'Apply Equipment Animation Bindings' },
    { key: 'updateAndOverwriteLinkAnimations', label: 'Apply Link Animation Bindings' },
    { key: 'removeExtraDatasets', label: 'Remove Extra Datasets' },
    { key: 'removeExtraColumns', label: 'Remove Extra Columns' },
    { key: 'noPropertyUpdates', label: 'Skip Property Updates' },
    { key: 'dryRun', label: 'Dry Run' }
  ];

  var state = {
    templateMode: classTemplates.length ? 'class-template' : 'paste',
    selectedClassTemplateRid: '',
    loadingClassTemplate: false,
    classTemplateError: '',
    templateContent: '',
    templateFileName: '',
    targetDeviceIds: '',
    requiredTemplateDevices: [],
    templateDeviceParseError: '',
    requiredDeviceSelections: [],
    expandedRequiredDeviceIndex: -1,
    overrideSelections: [{
      templateKey: 'override-device-0',
      rid: '',
      name: '',
      path: ''
    }],
    overrideExpandedDeviceIndex: -1,
    error: '',
    applying: false,
    loadingBooleanOptions: false,
    booleanOptionsError: '',
    booleanOptions: defaultBooleanOptions.slice(),
    runResult: null,
    selectedDevice: prop(null),
    overrideSelectedDevice: prop(null),
    updateDatasetBindings: false,
    overwriteDatasetBindings: false,
    createMissingDatasetsAndColumns: false,
    createMissingChildEquipment: false,
    updateAndOverwriteEquipmentAnimations: false,
    updateAndOverwriteLinkAnimations: false,
    removeExtraDatasets: false,
    removeExtraColumns: false,
    noPropertyUpdates: false,
    dryRun: false
  };

  var ensureBooleanStateKeys = function (booleanOptions) {
    (booleanOptions || []).forEach(function (option) {
      if (!option || !option.key) return;
      if (typeof state[option.key] !== 'boolean') {
        state[option.key] = false;
      }
    });
  };

  ensureBooleanStateKeys(state.booleanOptions);

  var syncTemplateRequiredDevices = function () {
    var parsed = templateDeviceSelector.parseRequiredDevicesFromTemplateText(state.templateContent);
    state.templateDeviceParseError = parsed.error || '';
    state.requiredTemplateDevices = parsed.devices || [];
    state.requiredDeviceSelections = templateDeviceSelector.buildSelectionList(
      state.requiredTemplateDevices,
      state.targetDeviceIds,
      state.requiredDeviceSelections,
      { preserveCustomRows: true }
    );
    if (state.expandedRequiredDeviceIndex >= state.requiredTemplateDevices.length) {
      state.expandedRequiredDeviceIndex = -1;
      state.selectedDevice(null);
    }
    if (state.requiredTemplateDevices.length) {
      state.overrideExpandedDeviceIndex = -1;
      state.overrideSelectedDevice(null);
    } else {
      var seededOverrideSelections = templateDeviceSelector.parseDeviceIdList(state.targetDeviceIds)
        .map(function (rid, idx) {
          return {
            templateKey: 'override-seeded-' + idx,
            rid: rid,
            name: '',
            path: ''
          };
        });
      var baseOverrideSelections = state.overrideSelections.length
        ? state.overrideSelections
        : seededOverrideSelections;
      var nextOverrideSelections = templateDeviceSelector.buildSelectionList(
        [],
        state.targetDeviceIds,
        baseOverrideSelections,
        { preserveCustomRows: true }
      );
      if (!nextOverrideSelections.length) {
        nextOverrideSelections = [{
          templateKey: 'override-device-0',
          rid: '',
          name: '',
          path: ''
        }];
      }
      state.overrideSelections = nextOverrideSelections;
    }
  };

  var fetchBindingBooleanOptions = function () {
    state.loadingBooleanOptions = true;
    state.booleanOptionsError = '';
    loaders.requestWithLoader({
      loader: 'background',
      method: 'GET',
      url: '/api/v1/binding/commands'
    })
      .then(function (response) {
        var commands = response && Array.isArray(response.commands) ? response.commands : [];
        var applyTemplateCommand = commands.find(function (command) {
          return command && command.key === 'apply-template';
        });
        var remoteBooleanOptions = applyTemplateCommand && Array.isArray(applyTemplateCommand.options)
          ? applyTemplateCommand.options
              .filter(function (option) {
                return option && option.type === 'boolean' && option.key;
              })
              .map(function (option) {
                return {
                  key: option.key,
                  label: option.label || option.key
                };
              })
          : [];
        if (remoteBooleanOptions.length) {
          state.booleanOptions = remoteBooleanOptions;
          ensureBooleanStateKeys(state.booleanOptions);
        }
      })
      .catch(function () {
        state.booleanOptionsError = 'Unable to load binding flags from Binding Tools. Using defaults.';
      })
      .finally(function () {
        state.loadingBooleanOptions = false;
        m.redraw();
      });
  };

  var loadTemplateFromClassTemplate = function (templateRid) {
    state.selectedClassTemplateRid = templateRid || '';
    state.classTemplateError = '';
    if (!templateRid) {
      state.templateContent = '';
      state.templateFileName = '';
      syncTemplateRequiredDevices();
      m.redraw();
      return Promise.resolve();
    }

    state.loadingClassTemplate = true;
    state.templateContent = '';
    state.templateFileName = '';
    syncTemplateRequiredDevices();
    m.redraw();

    return loaders.requestWithLoader({
      loader: 'background',
      method: 'POST',
      url: '/api/v1/binding/run',
      body: {
        command: 'export-template',
        options: {
          sourceEquipmentId: templateRid
        }
      }
    })
      .then(function (response) {
        if (!response || !response.download || !response.download.base64) {
          throw new Error('Template export did not return JSON content.');
        }
        var byteArray = base64ToUint8Array(response.download.base64);
        var rawText = decodeByteArrayToText(byteArray);
        try {
          state.templateContent = JSON.stringify(JSON.parse(rawText), null, 2);
        } catch (e) {
          state.templateContent = rawText;
        }
        var selectedTemplate = classTemplates.find(function (template) {
          return template && template.equipmentRid === templateRid;
        });
        state.templateFileName = selectedTemplate
          ? formatClassTemplateLabel(selectedTemplate)
          : (response.download.fileName || 'Template JSON');
        syncTemplateRequiredDevices();
      })
      .catch(function (error) {
        state.classTemplateError = extractErrorMessage(error) || 'Unable to load template JSON.';
      })
      .finally(function () {
        state.loadingClassTemplate = false;
        m.redraw();
      });
  };

  var setTemplateMode = function (mode) {
    if (state.applying || state.loadingClassTemplate) return;
    state.templateMode = mode;
    state.error = '';
    if (mode === 'upload') {
      state.templateContent = '';
      state.templateFileName = '';
      state.selectedClassTemplateRid = '';
      state.classTemplateError = '';
      syncTemplateRequiredDevices();
    }
    if (mode === 'paste') {
      state.selectedClassTemplateRid = '';
      state.classTemplateError = '';
    }
    if (mode === 'class-template') {
      if (!state.selectedClassTemplateRid && classTemplates.length) {
        loadTemplateFromClassTemplate(classTemplates[0].equipmentRid);
        return;
      }
    }
    syncTemplateRequiredDevices();
    m.redraw();
  };

  var submit = function () {
    if (state.applying) {
      return Promise.resolve();
    }
    if (state.loadingClassTemplate) {
      state.error = 'Please wait for template loading to complete.';
      m.redraw();
      return Promise.reject(new Error(state.error));
    }

    var templateContent = String(state.templateContent || '').trim();
    var targetDeviceIds = String(state.targetDeviceIds || '').trim();
    if (!templateContent) {
      state.error = 'Template JSON Content is required.';
      m.redraw();
      return Promise.reject(new Error(state.error));
    }
    if (!targetDeviceIds) {
      state.error = 'Target Device IDs is required.';
      m.redraw();
      return Promise.reject(new Error(state.error));
    }

    state.error = '';
    state.runResult = null;
    state.applying = true;
    modal.vm.hideCloseIcon(true);
    m.redraw();

    var requestOptions = {
      targetEquipmentId: targetEquipmentId,
      templateContent: templateContent,
      targetDeviceIds: targetDeviceIds
    };
    state.booleanOptions.forEach(function (toggle) {
      if (state[toggle.key] === true) {
        requestOptions[toggle.key] = true;
      }
    });

    return loaders.requestWithLoader({
      loader: 'submit',
      method: 'POST',
      url: '/api/v1/binding/run',
      body: {
        command: 'apply-template',
        options: requestOptions
      }
    })
      .then(function (response) {
        state.runResult = {
          success: response && response.success !== false,
          exitCode: typeof (response && response.exitCode) === 'number' ? response.exitCode : 0,
          stdout: response && response.stdout ? response.stdout : '',
          stderr: response && response.stderr ? response.stderr : ''
        };
      })
      .catch(function (error) {
        state.error = (error && error.error) || (error && error.message) || 'Error';
        if (error && (error.stdout || error.stderr || typeof error.exitCode === 'number')) {
          state.runResult = {
            success: false,
            exitCode: typeof error.exitCode === 'number' ? error.exitCode : 1,
            stdout: error && error.stdout ? error.stdout : '',
            stderr: error && error.stderr ? error.stderr : ''
          };
        }
        m.redraw();
      })
      .finally(function () {
        state.applying = false;
        modal.vm.hideCloseIcon(false);
        m.redraw();
      });
  };

  if (classTemplates.length) {
    loadTemplateFromClassTemplate(classTemplates[0].equipmentRid);
  }
  fetchBindingBooleanOptions();

	  modal.vm.title('Bind Equipment');
	  modal.vm.body = function () {
	    var hasClassTemplates = classTemplates.length > 0;
	    var showFallbackTargetDeviceInput = !state.requiredTemplateDevices.length &&
	      !(state.templateMode === 'class-template' && state.loadingClassTemplate);

    return m('div.relative', [
      state.error ? m('div.ba.b--light-red.bg-washed-red.dark-red.pa2.mb2.br2', state.error) : null,
      m('div.mb3', [
        m('div.f6.mid-gray', 'Target Equipment'),
        m('div.code', targetEquipmentId + (equipment && equipment.name ? (' - ' + equipment.name) : ''))
      ]),
      m('div.mb3', [
	        m('div.flex.items-center.justify-between.mb2', [
	          m('div.f3', 'Set template'),
	          m(templateInputModeTabs, {
	            className: 'flex',
	            activeKey: state.templateMode,
	            onSelect: setTemplateMode,
	            tabs: [
	              hasClassTemplates ? { key: 'class-template', label: 'Stored Templates' } : null,
	              { key: 'paste', label: 'Paste JSON' },
	              { key: 'upload', label: 'Upload File' }
	            ].filter(Boolean)
	          })
	        ]),
	        state.templateMode === 'class-template'
	          ? m('div', [
	              m('label.db.f5.mb1', { for: 'bind-equipment-template-selector' }, 'Template'),
	              m('select#bind-equipment-template-selector.w-100.ba.b--mid-gray.br2.pa2.mb2', {
	                value: state.selectedClassTemplateRid,
	                disabled: state.loadingClassTemplate || !hasClassTemplates,
	                onchange: function (event) {
	                  loadTemplateFromClassTemplate(event && event.target ? event.target.value : '');
	                }
	              }, hasClassTemplates
	                ? classTemplates.map(function (template) {
	                    return m('option', { value: template.equipmentRid, key: template.equipmentRid }, formatClassTemplateLabel(template));
	                  })
	                : [m('option', { value: '', key: 'no-class-template' }, 'No templates available')]
	              ),
	              !hasClassTemplates ? m('div.f6.gray.mb2', 'No saved templates are available for this equipment class.') : null,
	              state.loadingClassTemplate ? m('div.f6.gray.mb2', 'Loading template JSON...') : '',
	              state.classTemplateError ? m('div.f6.red.mb2', state.classTemplateError) : '',
	              m('textarea.w-100.ba.b--mid-gray.br2.pa2', {
                value: state.templateContent,
                readonly: true,
                style: {
                  height: '45vh',
                  resize: 'vertical'
                }
              })
            ])
          : state.templateMode === 'upload'
            ? m('div', [
                m(fileInput, {
                  field: {
                    id: 'equipment-apply-template-upload',
                    name: 'Upload File',
                    accept: '.json,.txt'
                  },
                  onChange: function (file) {
                    if (!file) {
                      state.templateFileName = '';
                      state.templateContent = '';
                      syncTemplateRequiredDevices();
                      return;
                    }
                    var reader = new FileReader();
                    reader.onload = function (event) {
                      state.templateFileName = file.name || '';
                      state.templateContent = (event && event.target && event.target.result) ? event.target.result : '';
                      syncTemplateRequiredDevices();
                      m.redraw();
                    };
                    reader.readAsText(file);
                  }
                }),
                m('div.f6.mid-gray.mb2', state.templateFileName || 'No file selected')
              ])
            : m('textarea.w-100.ba.b--mid-gray.br2.pa2', {
                value: state.templateContent,
                placeholder: 'Paste binding template JSON here',
                oninput: function (event) {
                  state.templateContent = event.target.value;
                  syncTemplateRequiredDevices();
                },
                style: {
                  height: '45vh',
                  resize: 'vertical'
                }
              })
      ]),
      m('div.mb3', [
        m('label.db.f3.mb2', 'Target Device IDs *'),
	        state.requiredTemplateDevices.length
	          ? templateDeviceSelector.renderRequiredDeviceSelector({
	              requiredDevices: state.requiredTemplateDevices,
	              selections: state.requiredDeviceSelections,
	              expandedIndex: state.expandedRequiredDeviceIndex,
	              selectedNode: state.selectedDevice,
	              disabled: state.applying,
	              allowAddRemoveRows: true,
	              sectionLabel: 'Required Devices',
	              rowCountLabel: '',
	              sectionHint: templateDeviceSelector.buildTargetDeviceHelpText(state.requiredTemplateDevices.length),
	              onToggleExpand: function (index) {
	                if (state.applying) return;
	                state.expandedRequiredDeviceIndex = state.expandedRequiredDeviceIndex === index ? -1 : index;
                state.selectedDevice(null);
              },
              onSelect: function (index, selectedDevice) {
                if (!selectedDevice || !selectedDevice['@rid']) return;
                var requiredDevice = state.requiredTemplateDevices[index] || {};
                state.requiredDeviceSelections[index] = {
                  templateKey: requiredDevice.key,
                  rid: selectedDevice['@rid'],
                  name: selectedDevice.name ? String(selectedDevice.name) : '',
                  path: selectedDevice.path ? String(selectedDevice.path) : '',
                  error: ''
                };
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(state.requiredDeviceSelections);
                state.expandedRequiredDeviceIndex = -1;
                state.selectedDevice(null);
              },
              onChangeRid: function (index, value) {
                var requiredDevice = state.requiredTemplateDevices[index] || {};
                var nextRid = String(value || '').trim();
                var existing = state.requiredDeviceSelections[index] || {};
                state.requiredDeviceSelections[index] = {
                  templateKey: requiredDevice.key,
                  rid: nextRid,
                  name: existing.rid === nextRid ? (existing.name || '') : '',
                  path: existing.rid === nextRid ? (existing.path || '') : '',
                  error: ''
                };
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(state.requiredDeviceSelections);
              },
              onBlurRid: function (index, value) {
                var normalizedRid = templateDeviceSelector.normalizeRid(value);
                templateDeviceSelector.resolveDeviceByRidWithError(normalizedRid)
                  .then(function (result) {
                    var selections = state.requiredDeviceSelections.slice();
                    var existing = selections[index];
                    if (!existing) return;
                    if (templateDeviceSelector.normalizeRid(existing.rid) !== normalizedRid) return;
                    selections[index] = Object.assign({}, existing, {
                      rid: (result && result.device && result.device.rid) || existing.rid,
                      name: (result && result.device && result.device.name) || '',
                      path: (result && result.device && result.device.path) || '',
                      error: (result && result.error) || ''
                    });
                    state.requiredDeviceSelections = selections;
                    state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
                    m.redraw();
                  });
              },
              onClear: function (index) {
                var requiredDevice = state.requiredTemplateDevices[index] || {};
                state.requiredDeviceSelections[index] = {
                  templateKey: requiredDevice.key,
                  rid: '',
                  name: '',
                  path: '',
                  error: ''
                };
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(state.requiredDeviceSelections);
              },
              onDeleteRow: function (index) {
                state.requiredDeviceSelections.splice(index, 1);
                if (state.expandedRequiredDeviceIndex === index) {
                  state.expandedRequiredDeviceIndex = -1;
                  state.selectedDevice(null);
                } else if (state.expandedRequiredDeviceIndex > index) {
                  state.expandedRequiredDeviceIndex = state.expandedRequiredDeviceIndex - 1;
                }
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(state.requiredDeviceSelections);
              },
              onAddRow: function () {
                var key = 'custom-device-' + Date.now() + '-' + state.requiredDeviceSelections.length;
                state.requiredDeviceSelections.push({
                  templateKey: key,
                  rid: '',
                  name: '',
                  path: ''
                });
              }
            })
          : null,
        (state.templateMode === 'class-template' && state.loadingClassTemplate)
          ? m('div.f6.gray.mb2', 'Loading template device requirements...')
          : null,
        state.templateDeviceParseError ? m('div.f6.gray.mb2', state.templateDeviceParseError) : null,
	        showFallbackTargetDeviceInput
	          ? templateDeviceSelector.renderRequiredDeviceSelector({
	              requiredDevices: [],
	              selections: state.overrideSelections,
	              expandedIndex: state.overrideExpandedDeviceIndex,
	              selectedNode: state.overrideSelectedDevice,
	              disabled: state.applying,
	              allowAddRemoveRows: true,
	              sectionLabel: '',
	              rowCountLabel: '',
	              sectionHint: templateDeviceSelector.buildTargetDeviceHelpText(0),
	              onToggleExpand: function (index) {
	                if (state.applying) return;
                state.overrideExpandedDeviceIndex = state.overrideExpandedDeviceIndex === index ? -1 : index;
                state.overrideSelectedDevice(null);
              },
              onSelect: function (index, selectedDevice) {
                if (!selectedDevice || !selectedDevice['@rid']) return;
                var rid = String(selectedDevice['@rid']);
                var selections = state.overrideSelections.slice();
                selections[index] = Object.assign({}, selections[index] || {}, {
                  templateKey: (selections[index] && selections[index].templateKey) || ('override-device-' + index),
                  rid: rid,
                  name: selectedDevice.name ? String(selectedDevice.name) : '',
                  path: selectedDevice.path ? String(selectedDevice.path) : '',
                  error: ''
                });
                state.overrideSelections = selections;
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
                state.overrideExpandedDeviceIndex = -1;
                state.overrideSelectedDevice(null);
              },
              onChangeRid: function (index, value) {
                var nextRid = String(value || '').trim();
                var selections = state.overrideSelections.slice();
                var existing = selections[index] || {};
                selections[index] = {
                  templateKey: existing.templateKey || ('override-device-' + index),
                  rid: nextRid,
                  name: existing.rid === nextRid ? String(existing.name || '') : '',
                  path: existing.rid === nextRid ? String(existing.path || '') : '',
                  error: ''
                };
                state.overrideSelections = selections;
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
              },
              onBlurRid: function (index, value) {
                var normalizedRid = templateDeviceSelector.normalizeRid(value);
                templateDeviceSelector.resolveDeviceByRidWithError(normalizedRid)
                  .then(function (result) {
                    var selections = state.overrideSelections.slice();
                    var existing = selections[index];
                    if (!existing) return;
                    if (templateDeviceSelector.normalizeRid(existing.rid) !== normalizedRid) return;
                    selections[index] = Object.assign({}, existing, {
                      rid: (result && result.device && result.device.rid) || existing.rid,
                      name: (result && result.device && result.device.name) || '',
                      path: (result && result.device && result.device.path) || '',
                      error: (result && result.error) || ''
                    });
                    state.overrideSelections = selections;
                    state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
                    m.redraw();
                  });
              },
              onClear: function (index) {
                var selections = state.overrideSelections.slice();
                var existing = selections[index] || {};
                selections[index] = {
                  templateKey: existing.templateKey || ('override-device-' + index),
                  rid: '',
                  name: '',
                  path: '',
                  error: ''
                };
                state.overrideSelections = selections;
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
              },
              onDeleteRow: function (index) {
                var selections = state.overrideSelections.slice();
                selections.splice(index, 1);
                if (!selections.length) {
                  selections.push({
                    templateKey: 'override-device-0',
                    rid: '',
                    name: '',
                    path: ''
                  });
                }
                state.overrideSelections = selections;
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
                if (state.overrideExpandedDeviceIndex === index) {
                  state.overrideExpandedDeviceIndex = -1;
                  state.overrideSelectedDevice(null);
                } else if (state.overrideExpandedDeviceIndex > index) {
                  state.overrideExpandedDeviceIndex = state.overrideExpandedDeviceIndex - 1;
                }
              },
              onAddRow: function () {
                var selections = state.overrideSelections.slice();
                selections.push({
                  templateKey: 'override-device-' + Date.now() + '-' + selections.length,
                  rid: '',
                  name: '',
                  path: ''
                });
                state.overrideSelections = selections;
                state.targetDeviceIds = templateDeviceSelector.composeTargetDeviceIds(selections);
                state.overrideExpandedDeviceIndex = -1;
                state.overrideSelectedDevice(null);
              }
            })
          : null
      ]),
      state.loadingBooleanOptions ? m('div.f6.gray.mb2', 'Loading binding flags...') : null,
      state.booleanOptionsError ? m('div.f6.mid-gray.mb2', state.booleanOptionsError) : null,
      m('div.mb2', state.booleanOptions.map(function (toggle) {
        var inputId = 'apply-template-toggle-' + toggle.key;
        return m('div.flex.items-center.justify-between.mb2', [
          m('label.f5', { for: inputId }, toggle.label),
          m(ToggleSwitch, {
            id: inputId,
            checked: state[toggle.key] === true,
            disabled: state.applying,
            onchange: function () {
              state[toggle.key] = !state[toggle.key];
            }
          })
        ]);
      })),
      state.runResult ? m('div.mt3', [
        m('div.f5.mb2', state.runResult.success ? 'Bind completed.' : 'Bind completed with errors.'),
        m('div.f6.gray.mb2', 'Exit code: ' + (typeof state.runResult.exitCode === 'number' ? state.runResult.exitCode : 'n/a')),
        m('div.flex.flex-column.flex-row-ns.mt2', [
          m('div.w-100.w-50-ns.pr0.pr3-ns', [
            m('div.f6.b.mb1', 'STDOUT'),
            m('pre.code.ba.b--mid-gray.pa2', {
              style: { maxHeight: '20rem', overflow: 'auto' }
            }, state.runResult.stdout ? state.runResult.stdout : '(no output)')
          ]),
          m('div.w-100.w-50-ns.pl0.pl3-ns.mt3.mt0-ns', [
            m('div.f6.b.mb1', 'STDERR'),
            m('pre.code.ba.b--mid-gray.pa2', {
              style: { maxHeight: '20rem', overflow: 'auto' }
            }, state.runResult.stderr ? state.runResult.stderr : '(no output)')
          ])
        ])
      ]) : null
    ]);
  };

  modal.vm.buttons([
    {
      label: 'Bind Equipment',
      class: 'btn-good dib mr2',
      func: submit
    },
    {
      label: 'Close',
      class: 'dib',
      func: function () {
        if (state.applying) return Promise.resolve();
        modal.vm.close();
      }
    }
  ]);
  modal.vm.open({ extrawidth: true });
};

module.exports = bindEquipmentModal;
